module.exports = __webpack_public_path__ + "img/pen-fancy-slash.899e2a3c.svg";